<template>
  <footer class="footer py-4 px-3">
    <b-container fluid>
      <b-row>
        <b-col md="4">
          <div class="h-100 d-flex flex-column justify-content-between">
            <div>
              <willis-logo height="15" />
            </div>
            <div>
              <b-link
                class="text-white text-decoration-underline"
                variant="link"
                @click="scrollToTop"
              >
                {{ $t('footer.return-to-top') }}
              </b-link>
            </div>
          </div>
        </b-col>
        <b-col md="4">
          <div class="mb-1">
            <locale-changer />
          </div>
          <div class="mb-1">
            <b-link
              class="text-white"
              href="https://www.willistowerswatson.com/en-US/About-Us/overview"
              target="_blank"
              rel="noopener"
            >
              {{ $t('footer.about-willis') }}
            </b-link>
          </div>
          <div class="mb-1">
            <b-link
              class="text-white"
              href="https://www.willistowerswatson.com/en-US/About-Us/office-locations"
              target="_blank"
              rel="noopener"
            >
              {{ $t('footer.office-locations') }}
            </b-link>
          </div>
          <div class="mb-1">
            <b-link
              class="text-white"
              href="https://www.willistowerswatson.com/en-US/Notices/terms-of-use"
              target="_blank"
              rel="noopener"
            >
              {{ $t('footer.terms-of-use') }}
            </b-link>
          </div>
          <div class="mb-1">
            <b-link
              class="text-white"
              href="https://www.willistowerswatson.com/en-US/Notices/global-website-privacy-notice"
              target="_blank"
              rel="noopener"
            >
              {{ $t('footer.privacy-policy') }}
            </b-link>
          </div>
          <div class="mb-1">
            <b-link
              class="text-white"
              href="/v2/#/cookie-notice"
              target="_blank"
              rel="noopener"
            >
              {{ $t('footer.cookies') }}
            </b-link>
          </div>
          <div class="mb-1">
            <b-link
              class="text-white"
              href="https://www.wtwdataservices.com/twds/public/SignIn?return=https://www.wtwdataservices.com/twds/private/MyAccount/myAccount.jsp"
              target="_blank"
              rel="noopener"
            >
              {{ $t('footer.my-account') }}
            </b-link>
          </div>
          <div class="mb-1">
            <b-link
              class="text-white"
              href="https://support.ehr.com/servicedesk/customer/portal/33"
              target="_blank"
              rel="noopener"
            >
              {{ $t('footer.service-center') }}
            </b-link>
          </div>
        </b-col>
        <b-col md="4">
          <div
            class="h-100 bg-dark d-flex flex-column justify-content-between p-4"
          >
            <div class="text-uppercase">{{ $t('footer.need-help') }}</div>
            <div>
              {{ $t('footer.question') }}
            </div>
            <div>
              <b-link
                class="text-white text-decoration-underline"
                variant="link"
                href="https://www.wtwrewardsdataintel.com/s/contact-us"
                target="_blank"
                rel="noopener"
              >
                {{ $t('footer.contact-us') }}
              </b-link>
            </div>
          </div>
        </b-col>
      </b-row>

      <hr class="border-light" />

      <b-row>
        <b-col md="12">
          <div
            class="d-flex flex-row justify-content-between align-items-center"
          >
            <div class="sitemap">
              <b-link
                class="text-white"
                href="https://www.wtwco.com/en-us"
                target="_blank"
                rel="noopener"
              >
                {{ $t('footer.home') }}
              </b-link>
              <span class="separator" />
              <b-link
                class="text-white"
                href="https://www.wtwco.com/en-us/news/all-news#sort=%40fdate13762%20descending"
                target="_blank"
                rel="noopener"
              >
                {{ $t('footer.news') }}
              </b-link>
              <span class="separator" />
              <b-link
                class="text-white"
                href="https://www.wtwco.com/en-us/solutions/future-of-work#generic-related-products"
                target="_blank"
                rel="noopener"
              >
                {{ $t('footer.products') }}
              </b-link>
              <span class="separator" />
              <b-link
                class="text-white"
                href="https://www.wtwrewardsdataintel.com/s/"
                target="_blank"
                rel="noopener"
              >
                {{ $t('footer.participate') }}
              </b-link>
              <span class="separator" />
              <b-link
                class="text-white"
                href="https://compensationsoftware.ehr.com/Home/Authentication"
                target="_blank"
                rel="noopener"
              >
                {{ $t('footer.compensation-software') }}
              </b-link>
            </div>
            <div>
              <span>
                {{ $t('footer.copyright') }}
              </span>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </footer>
</template>

<script>
import WillisLogo from '@/components/WillisLogo'
import LocaleChanger from '@/components/LocaleChanger'

export default {
  components: { WillisLogo, LocaleChanger },

  methods: {
    scrollToTop() {
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  background: black;
  color: white;
  font-size: 0.9rem;
}

.separator {
  position: relative;
  padding: 0 1rem;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 40%;
    width: 1px;
    height: 100%;

    transform: translateX(-50%);

    border-right: solid rgba(#ffffff, 0.3) 1px;
  }
}
</style>
